/**
 * Tâche 1301 (Eric 2026-09-25) — « On a vérifié, il n'y a pas de limitation
 * de crédits. Es-tu sûr de cette cause ? »
 *
 * Le test de connexion historique faisait un GET, qui répond 200 même quand
 * AssemblyAI refuse toutes les soumissions. Et une organisation peut avoir
 * plusieurs comptes AssemblyAI : le tableau de bord consulté n'est pas
 * forcément celui de la clé enregistrée. Ce bouton tranche : il tente une
 * vraie soumission (URL injoignable, donc sans coût) et affiche les dernières
 * transcriptions DU COMPTE de la clé, qui l'identifient sans discussion.
 */
import { useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const AssemblyAiDiagnosticButton = ({ lang = "fr" }) => {
  const [chargement, setChargement] = useState(false);
  const [res, setRes] = useState(null);
  const [erreur, setErreur] = useState(null);

  const lancer = async () => {
    setChargement(true);
    setErreur(null);
    setRes(null);
    try {
      const { data } = await axios.get(
        `${API}/api/org/ai-package/assemblyai/diagnostic?lang=${lang}`,
        { withCredentials: true, timeout: 60000 }
      );
      setRes(data);
    } catch (e) {
      setErreur(e?.response?.data?.detail || (lang === "fr" ? "Diagnostic impossible." : "Diagnostic failed."));
    } finally {
      setChargement(false);
    }
  };

  const bloque = res?.soumission?.bloque;

  return (
    <div className="mb-4" data-testid="assemblyai-diagnostic">
      <button
        onClick={lancer}
        disabled={chargement}
        className="px-3 py-1.5 rounded-lg border border-zinc-300 hover:border-zinc-500 disabled:opacity-50 text-xs font-semibold text-zinc-700 transition-colors"
        data-testid="assemblyai-diagnostic-btn"
      >
        {chargement
          ? (lang === "fr" ? "⏳ Interrogation d'AssemblyAI…" : "⏳ Querying AssemblyAI…")
          : (lang === "fr" ? "🎙️ Diagnostic AssemblyAI (quel compte ?)" : "🎙️ AssemblyAI diagnostic (which account?)")}
      </button>

      {erreur && (
        <p className="mt-2 text-xs text-red-700" data-testid="assemblyai-diagnostic-error">{erreur}</p>
      )}

      {res && (
        <div
          className={`mt-3 rounded-lg border p-3 text-xs ${
            bloque ? "bg-red-50 border-red-300 text-red-900" : "bg-teal-50 border-teal-300 text-teal-900"
          }`}
          data-testid="assemblyai-diagnostic-result"
        >
          <p className="font-semibold" data-testid="assemblyai-diagnostic-verdict">
            {res.verdict}
          </p>
          <p className="mt-1">
            {lang === "fr" ? "Clé utilisée par le pipeline" : "Key used by the pipeline"} :{" "}
            <span className="font-mono">••••{res.key_last4}</span> ({res.key_source})
          </p>
          {res.soumission?.motif && (
            <p className="mt-1 font-mono break-all" data-testid="assemblyai-diagnostic-motif">
              {lang === "fr" ? "Réponse brute d'AssemblyAI" : "Raw AssemblyAI response"} : {res.soumission.motif}
            </p>
          )}
          {!!res.dernieres_transcriptions_du_compte?.length && (
            <div className="mt-2">
              <p className="font-semibold">
                {lang === "fr"
                  ? "Dernières transcriptions de CE compte"
                  : "Latest transcriptions of THIS account"}
              </p>
              <ul className="mt-1 space-y-0.5" data-testid="assemblyai-diagnostic-history">
                {res.dernieres_transcriptions_du_compte.map((t) => (
                  <li key={t.id} className="font-mono">
                    {(t.created || "").slice(0, 19)} · {t.status}
                    {t.audio_duration ? ` · ${t.audio_duration}s` : ""}
                    {t.audio_host ? ` · ${t.audio_host}` : ""}
                  </li>
                ))}
              </ul>
            </div>
          )}
          <p className="mt-2 italic">{res.note}</p>
        </div>
      )}
    </div>
  );
};

export default AssemblyAiDiagnosticButton;
